import { Breadcrumb, BreadcrumbProps } from 'antd';

export type { BreadcrumbProps } from 'antd';

export const Breadcrumbs = (props: BreadcrumbProps) => {
  return <Breadcrumb {...props} />;
};
